import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import md5 from 'md5';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

import Loading from '../../dialogs/loading';
import Error from '../../dialogs/Error';

import { bindActionCreators } from 'redux';
import * as actionsprocess from '../../../actions/api.manual.process.actions';
import * as actionslaunch from '../../../actions/api.manage.process.actions';
import * as actions from '../../../actions/employee.actions';

import randomstring from 'uuid/v4';

class LaunchByHand extends React.Component {
    constructor(props) {
        super(props);
        props.loadManualProcesses();
        props.loadEmployees(undefined, undefined, true);
    }

    state = {
        local: undefined,
        family: this.props.family,
        process: undefined,
        loading: false,
        employee: undefined
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClick = (family, process) => {
        this.setState({ family: family, process: process });
    }

    handleClose = () => (event) => {
        this.props.onClose();
    };

    handleSummit = (family, process, local, employee) => (event) => {
        this.setState({ loading: true });
        this.props
            .launch(process, local, employee)
            .then((r) => {
                if (r.error) {
                    this.props.onError(r.error.message);
                } else if (r && r.id) {
                    this.props.history.push(`/processes/${md5(family)}/${process}/${r.id}`);
                } else {
                    this.props.onClose(true);
                }
            })
            .catch((error) => this.props.onError(error.message));
    };

    render() {
        let { family, process, local, loading, employee } = this.state;
        const {
            intl,
            info,
            manual_process,
            manual_process_is_loading,
            manual_process_has_error,
            employees
        } = this.props;

        if (manual_process_is_loading || loading) {
            return <Loading open opacity />;
        } else if (manual_process_has_error.hasErrored) {
            return (
                <Error
                    open
                    message={manual_process_has_error.error}
                    handleClose={this.handleBack}
                />
            );
        } else {
            const processes =
                manual_process && family
                    ? manual_process.find((f) => f.nombre === family)
                    : undefined;

            let nodes = [];
            let proceso = undefined;
            if (processes) {
                proceso = processes.procesos.find((f) => f.codigo === process);
                if (proceso && proceso.locales) {
                    nodes = info.security.locals.reduce((arr, c) => {
                        if (c.leaf && proceso.locales.indexOf(c.id) >= 0) {
                            arr.push(c);
                        }
                        return arr;
                    }, []);
                } else {
                    nodes = [];
                }
            }

            if(nodes.length === 1) {
                local = nodes[0].id;
            }
            
            return (
                <Dialog
                    open={true}
                    onClose={this.handleClose()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="simple-dialog-title">
                        <FormattedMessage id="LaunchByHand" />
                    </DialogTitle>
                    <DialogContent className={'padding_borders'}>
                        {
                            manual_process.map((f) =>{
                                return f.procesos
                                    .filter((f) => f.mru !== null && f.mru !== undefined)
                                    .map((p) => {
                                        console.log(p);
                                        return  <div 
                                                    key={randomstring()}
                                                    className="boxShadow padding_borders c_bluish bg_white barlow_regular_smalltext hand center margin_top_12 margin_bottom_24"
                                                    onClick={() => this.handleClick(f.nombre, p.codigo) }>
                                                    {p.nombre}
                                                </div>
                                    
                                    })
                            })

                        }
                        <div className="flex_full_row align_center">
                            <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                <InputLabel htmlFor="age-native-simple" className="upper" shrink>
                                    {intl.formatMessage({ id: 'family' })}
                                </InputLabel>
                                <Select
                                    native
                                    value={family}
                                    onChange={this.handleChange}
                                    inputProps={{ name: 'family', id: 'family-id' }}
                                    className="upper"
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {manual_process &&
                                        manual_process
                                            .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                            .map((f) => {
                                                return (
                                                    <option
                                                        key={randomstring()}
                                                        className="upper"
                                                        value={f.nombre}
                                                    >
                                                        {f.nombre.toUpperCase()}
                                                    </option>
                                                );
                                            })}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="flex_full_row align_center margin_top_18">
                            <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                <InputLabel htmlFor="age-native-simple" className="upper" shrink>
                                    {intl.formatMessage({ id: 'process' })}
                                </InputLabel>
                                <Select
                                    native
                                    value={process}
                                    onChange={this.handleChange}
                                    inputProps={{ name: 'process', id: 'process-id' }}
                                    className="upper"
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {processes &&
                                        processes.procesos
                                            .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                            .map((f) => {
                                                return (
                                                    <option
                                                        key={randomstring()}
                                                        className="upper"
                                                        value={f.codigo}
                                                    >
                                                        {f.nombre.toUpperCase()}
                                                    </option>
                                                );
                                            })}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="flex_full_row align_center margin_top_18">
                            <FormControl
                                className={'flex_full width100 barlow_italic c_slate upper'}
                            >
                                <InputLabel htmlFor="age-native-simple" className="upper" shrink>
                                    {intl.formatMessage({ id: 'type_label_local' })}
                                </InputLabel>
                                <Select
                                    native
                                    value={local}
                                    onChange={this.handleChange}
                                    inputProps={{ name: 'local', id: 'local-id' }}
                                    className="upper"
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {nodes &&
                                        nodes
                                            .sort((a, b) => (a.name < b.name ? -1 : 1))
                                            .map((cat) => {
                                                return (
                                                    <option
                                                        key={randomstring()}
                                                        className="upper"
                                                        value={cat.id}
                                                    >
                                                        {cat.name.toUpperCase()}
                                                    </option>
                                                );
                                            })}
                                </Select>
                            </FormControl>
                        </div>
                        {(proceso && proceso.paraTrabajador && local)
                            ? <div className="flex_full_row align_center margin_top_18">
                                <FormControl className={'flex_full width100 barlow_italic c_slate upper'}>
                                    <InputLabel htmlFor="age-native-simple" className="upper" shrink>
                                        {intl.formatMessage({ id: 'employee' })}
                                    </InputLabel>
                                    <Select
                                        native
                                        value={employee}
                                        onChange={this.handleChange}
                                        inputProps={{ name: 'employee', id: 'employee-id' }}
                                        className="upper"
                                    >
                                        <option key={randomstring()} value={undefined} />
                                        {employees &&
                                            employees
                                                .filter((f) =>  f.locales.map((l) => l.id).indexOf(parseInt(local, 10)) >= 0 && f.consentimiento === true )
                                                .sort((a, b) =>
                                                    a.nombre.toUpperCase().trim() + ' ' + a.apellidos.toUpperCase() <
                                                        b.nombre.toUpperCase().trim() + ' ' + b.apellidos.toUpperCase()
                                                        ? -1
                                                        : 1,
                                                )
                                                .map((a) => {
                                                    return (
                                                        <option
                                                            key={randomstring()}
                                                            className="upper"
                                                            value={a.id}
                                                        >
                                                            {
                                                                a.nombre.toUpperCase().trim() + ' ' +a.apellidos.toUpperCase()
                                                            }
                                                        </option>
                                                    );
                                                })}
                                    </Select>
                                </FormControl>
                            </div>
                            : <div className="cleandiv"/>
                        }


                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose()} color="primary">
                            <FormattedMessage id="cancel" />
                        </Button>
                        <Button
                            disabled={!(family && process && (local || nodes.length === 1) && ( proceso && (!proceso.paraTrabajador || employee )) )}
                            onClick={this.handleSummit(family, process, local, employee)}
                            color="primary"
                            autoFocus
                        >
                            <FormattedMessage id="accept" />
                        </Button>
                    </DialogActions>
                </Dialog>
            );
        }
    }
}

LaunchByHand.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
    manual_process: PropTypes.array.isRequired,
    manual_process_is_loading: PropTypes.bool.isRequired,
    manual_process_has_error: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        manual_process: state.manual_process,
        manual_process_is_loading: state.manual_process_is_loading,
        manual_process_has_error: state.manual_process_has_error,
        employees: state.employees,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsprocess, actionslaunch, actions), dispatch);
};

LaunchByHand = withRouter(LaunchByHand);

LaunchByHand = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LaunchByHand);

LaunchByHand = injectIntl(LaunchByHand);

export default LaunchByHand;



// WEBPACK FOOTER //
// ./src/components/complex/families/LaunchByHand.js